import { SEARCH_NAMES } from "constant/search/search";

export const DL_UNIT_PER_PAGE_MAX = 5;

export const UNIT_SEARCH_OPTIONS = [
  SEARCH_NAMES.SEARCH_TEXT,
  SEARCH_NAMES.LIMIT,
  SEARCH_NAMES.SKIP,
  SEARCH_NAMES.GROUP_SLUG,
  SEARCH_NAMES.INCLUDE_HM2,
  SEARCH_NAMES.U_TYPE,
] as const;

export type UnitSearchOptions = (typeof UNIT_SEARCH_OPTIONS)[number];

export const MAX_NUM_NAV = 30;
